export default [
  {
    path: '/app/tenants',
    name: 'Tenants',
    component: () => import('@/views/Admin/Tenants/Index.vue'),
    meta: {
      pageTitle: 'Kiracılar',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'ADMIN_TENANTS',
      action: 'read',
    },
  },
  {
    path: '/app/tenants/add',
    name: 'TenantAdd',
    component: () => import('@/views/Admin/Tenants/Add.vue'),
    meta: {
      pageTitle: 'Kiracılar',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/tenants',
          active: false,
        },
        {
          text: 'Oluştur',
          active: true,
        },
      ],
      resource: 'ADMIN_TENANTS',
      action: 'read',
    },
  },
  {
    path: '/app/tenants/edit/:id',
    name: 'TenantEdit',
    component: () => import('@/views/Admin/Tenants/Edit.vue'),
    meta: {
      pageTitle: 'Kiracılar',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/tenants',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'ADMIN_TENANTS',
      action: 'read',
    },
  },
]
